import { HUB_ENDPOINTS, PROD_HUB_BASE_URL } from "@memorang/constants/urls";
import type { AiAssistantInfo } from "@memorang/ui/components/ChatUI/types";
import { interpolateString } from "./helpers";

export const ENDPOINT_RESEND_EMAIL = `${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.SEND_EMAIL}`;
export const ENDPOINT_RECOMMENDED_QUERIES = `${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.RECOMMENDED_QUERIES}`;
export const ENDPOINT_AIRTABLE_FEEDBACK = `${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.FEEDBACK}`;
export const ENDPOINT_THREADS = `${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.THREADS}`;
export const ENDPOINT_ASSISTANT_SESSION_REVIEW = `${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.ASSISTANT_SESSION_REVIEW}`;
export const RECOMMENDED_QUESTIONS_QUERY_KEY = "RECOMMENDED_QUESTIONS";
export const GET_THREAD_QUERY_KEY = "THREAD";

export const summaryActionIcons = (
	showEmail?: boolean,
	isEmailSent?: boolean,
) => [
	...(showEmail
		? [
				{
					icon: "email-outline",
					type: "email",
					tooltip: isEmailSent
						? "report.sessionAnalysis.menuActions.emailAlreadySent"
						: "report.sessionAnalysis.menuActions.emailSummary",
					disabled: isEmailSent,
				},
			]
		: []),
];

export const feedbackActionIcons = [
	{
		icon: "content-copy",
		type: "copy",
		tooltip: "report.sessionAnalysis.menuActions.copy",
	},
	{
		icon: "thumb-up-outline",
		type: "feedback-positive",
		tooltip: "report.sessionAnalysis.menuActions.positiveFeedback",
		disabled: false,
	},
	{
		icon: "thumb-down-outline",
		type: "feedback-negative",
		tooltip: "report.sessionAnalysis.menuActions.negativeFeedback",
	},
	{
		icon: "flag-outline",
		type: "report-issue",
		tooltip: "report.sessionAnalysis.menuActions.reportIssue",
	},
];

export const events = {
	copilotFeedbackSubmitted: "mem_copilot_feedback_submitted",
	copilotResponseCopyClicked: "mem_copilot_response_copy_clicked",
	sessionReportSummaryCopyClicked: "mem_session_report_summary_copy_clicked",
	sessionReportFeedbackProvided: "mem_session_report_feedback_provided",
	positiveFeedbackSubmitted: "mem_positive_feedback_submitted",
	negativeFeedbackSubmitted: "mem_negative_feedback_submitted",
	feedbackSubmitted: "mem_feedback_submitted",
	copilotFollowupSelected: "mem_copilot_followup_selected",
	copilotTextSubmitted: "mem_copilot_text_submitted",
	clearedQuery: "mem_cleared_query",
	emailTriggered: "mem_email_triggered",
	emailSent: "mem_email_sent",
	chatOpened: "mem_chat_opened",
	reportContentClicked: "mem_report_content_clicked",
	aiFeedbackPositive: "mem_ai_feedback_positive",
	aiFeedbackNegative: "mem_ai_feedback_negative",
	aiFeedbackReport: "mem_ai_feedback_report",
	dialogOpened: "mem_dialog_opened",
	dialogClosed: "mem_dialog_closed",
};

export const searchContexts = {
	currentView: "Current View",
	currentBook: "Current Book",
	allFilteredBooks: "All Filtered Books",
} as const;

export const initialAiMessage = (
	initialMessage: string,
	context: string,
	topic: string,
	aiAssistantInfo: Omit<AiAssistantInfo, "icon">,
) =>
	interpolateString(initialMessage, {
		alias: aiAssistantInfo.alias,
		title: aiAssistantInfo.title,
		context: context ?? "your exam",
		topic,
	});
